import { useEffect, useState } from "react";
import { Card, CardContent } from "../ui/card";
import { Loader2, Target, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Focus Day compromisos widget for Inicio dashboard. */
export function FocusDayWidget({ token }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!token) return;
    let c = false;
    (async () => {
      try {
        const r = await fetch(`${API}/focus-day/commitments/mine`, { headers: { Authorization: `Bearer ${token}` } });
        if (r.ok) { const j = await r.json(); if (!c) setData(j); }
      } catch { /* silent */ }
      finally { if (!c) setLoading(false); }
    })();
    return () => { c = true; };
  }, [token]);

  if (loading) return <Card><CardContent className="p-4 flex justify-center"><Loader2 className="w-4 h-4 animate-spin text-emerald-600" /></CardContent></Card>;
  if (!data || (!data.overdue?.length && !data.upcoming?.length)) return null;

  return (
    <Card data-testid="focus-day-widget">
      <CardContent className="p-4">
        <div className="flex items-start justify-between mb-2">
          <div>
            <div className="text-[10px] uppercase tracking-widest text-emerald-700 font-semibold">Focus Day</div>
            <h3 className="text-base font-bold flex items-center gap-2"><Target className="w-4 h-4 text-emerald-600" />Mis compromisos</h3>
          </div>
          <Link to="/focus-day" className="text-xs text-emerald-700 hover:underline flex items-center" data-testid="focus-day-widget-open">
            Ver todos <ArrowRight className="w-3 h-3 ml-1" />
          </Link>
        </div>
        {data.overdue?.length > 0 && (
          <div className="mb-2">
            <div className="text-[10px] font-semibold text-red-700 uppercase tracking-wide mb-1">Vencidos ({data.overdue.length})</div>
            {data.overdue.slice(0, 3).map((c, i) => (
              <div key={c.id} className="text-xs py-0.5 flex items-center gap-2" data-testid={`fd-widget-overdue-${i}`}>
                <span className="w-1.5 h-1.5 rounded-full bg-red-500 flex-shrink-0" />
                <span className="truncate flex-1">{c.title}</span>
                <span className="text-red-700 font-mono">{c.due_date}</span>
              </div>
            ))}
          </div>
        )}
        {data.upcoming?.length > 0 && (
          <div>
            <div className="text-[10px] font-semibold text-slate-600 uppercase tracking-wide mb-1">Próximos ({data.upcoming.length})</div>
            {data.upcoming.slice(0, 3).map((c, i) => (
              <div key={c.id} className="text-xs py-0.5 flex items-center gap-2" data-testid={`fd-widget-upcoming-${i}`}>
                <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 flex-shrink-0" />
                <span className="truncate flex-1">{c.title}</span>
                <span className="text-slate-500 font-mono">{c.due_date}</span>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
